import React from 'react';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteWikiCategoryItemMutation,
  useGetWikiCategoriesQuery,
} from '../../../../../../redux/services/wikiApi.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useTranslation } from 'react-i18next';
import CategoriesTable from './CategoriesTable.jsx';

const CategoryPage = () => {
  const navigate = useNavigate();
  const { deleteSuccess, deleteFailed } = useToastMessages();
  const { t } = useTranslation();

  const { data: wikiCategories, isLoading, refetch } = useGetWikiCategoriesQuery();
  const [deleteWikiCategoryItem] = useDeleteWikiCategoryItemMutation();

  const handleDelete = async (id) => {
    try {
      await deleteWikiCategoryItem(id).unwrap();
      deleteSuccess();
      refetch();
    } catch (err) {
      deleteFailed(err);
    }
  };

  if (isLoading) return <Spinner />;

  return (
    <div>
      <AppBarCMS
        title={t('Kategórie Wiki stránok')}
        backUrl={routes.cmsWikiPages}
        backUrlTooltip={t('FRI.wiki')}
        createText={t('Pridať kategóriu')}
        createUrl={routes.cmsWikiCategoryCreate}
        permissionsBasic={'wiki-categories'}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <CategoriesTable
            wikiCategories={wikiCategories}
            onDelete={(record) => handleDelete(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsWikiCategoryEdit}/${record.id}`)
            }
          />
        </CollapseBlock>
      </div>
    </div>
  );
};

export default CategoryPage;

